import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";

interface ResponseStatusChipProps {
  isResponseComplete?: boolean;
}

export const ResponseStatusChip: FC<ResponseStatusChipProps> = ({ isResponseComplete }) => {
  const hasResponded = isResponseComplete === true;

  return (
    <Chip
      size={ChipSize.ExtraSmall}
      backgroundColor={hasResponded ? ChipBackgroundColor.Green : ChipBackgroundColor.Yellow}
    >
      {getString(
        hasResponded ? "campaigns.responseStatus.responded" : "campaigns.responseStatus.pending"
      )}
    </Chip>
  );
};
